import cn from 'classnames';
import Burger from 'molecules/Burger';
import AuthNav from 'organisms/Navigation/AuthNav';
import React from 'react';
import { INavItem } from 'utils/globalTypes';

import s from './Navigation.module.scss';

interface IRightNav {
  transparent: boolean;
  isImpersonatedMode?: boolean;
  dark: boolean;
  isSticky?: boolean;
  burgerMenuItems: Array<INavItem>;
  onAction: (actionName: string, url?: string) => void;
}

const RightNav = ({
  transparent,
  dark,
  isSticky,
  burgerMenuItems,
  onAction,
  isImpersonatedMode
}: IRightNav) => {
  return (
    <div className={cn(s.Navigation__rightWrapper, { isImpersonatedMode })}>
      <AuthNav transparent={transparent} dark={dark} isSticky={isSticky} onAction={onAction} />
      <div className={s.Navigation__burgerWrapper}>
        <Burger
          navItems={burgerMenuItems}
          transparent={transparent}
          dark={dark}
          isSticky={isSticky}
          onAction={onAction}
        />
      </div>
    </div>
  );
};

export default RightNav;
